abstract class DolfinLogger {
  log(_message?: any): void {}

  error(_message?: any): void {}

  warn(_message?: any): void {}

  info(_message?: any): void {}
}

export default DolfinLogger
